module.exports = __webpack_public_path__ + "img/daishenzhapaiqikong.77da19b1.jpg";